import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../../context/ThemeContext";
import "../../../pages/Landing/LandingPage.css";

const Pricing = () => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <section
      className={`pricing-section py-5 ${darkMode ? "dark-mode" : ""}`}
      id="pricing"
    >
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2 className="pricing-title">Software & Service Plans</h2>
          <p className="pricing-subtitle">
            Choose the perfect plan for your business needs
          </p>
        </div>

        <div className="row pricing-cards g-3">
          <div
            className="col-lg-3 col-md-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="pricing-card">
              <div className="pricing-card-content">
                <div className="pricing-card-header">
                  <h3 className="plan-name">Free</h3>
                  <div className="price-display">
                    <span className="price-text">$0</span>
                    <span>/month</span>
                  </div>
                  <p className="plan-description">
                    Ideal for individuals exploring the system
                  </p>
                </div>
                <div className="plan-features">
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">1 User only</span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Basic Sales & Purchase Management
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Basic inventory tracking
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Create and send invoices & quotes
                    </span>
                  </div>
                </div>
                <div className="plan-cta">
                  <button
                    className="plan-btn"
                    onClick={() => (window.location.href = "/pricing#free")}
                  >
                    See More...
                  </button>
                </div>
              </div>
              <div className="pricing-card-glass"></div>
            </div>
          </div>

          <div
            className="col-lg-3 col-md-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="pricing-card plan-blue">
              <div className="pricing-tag">Most Popular</div>
              <div className="pricing-card-content">
                <div className="pricing-card-header">
                  <h3 className="plan-name">Pro</h3>
                  <div className="price-display">
                    <span className="price-currency">$</span>
                    <span className="price-text">10</span>
                    <span>/month per user</span>
                  </div>
                  <p className="plan-description">
                    Perfect for solo professionals or small businesses
                  </p>
                </div>
                <div className="plan-features">
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Interactive Business Dashboard
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Revenue & invoice analytics
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Customer aging & payment tracking
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      AI-powered Suggestions & Insights
                    </span>
                  </div>
                </div>
                <div className="plan-cta">
                  <button
                    className="plan-btn"
                    onClick={() => (window.location.href = "/pricing#pro")}
                  >
                    See More...
                  </button>
                </div>
              </div>
              <div className="pricing-card-glass"></div>
            </div>
          </div>

          <div
            className="col-lg-3 col-md-6"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="pricing-card">
              <div className="pricing-save-tag">Best Value</div>
              <div className="pricing-card-content">
                <div className="pricing-card-header">
                  <h3 className="plan-name">Team</h3>
                  <div className="price-display">
                    <span className="price-currency">$</span>
                    <span className="price-text">15</span>
                    <span>/month</span>
                  </div>
                  <p className="plan-description">
                    Includes 2 users (each additional user: $10/month)
                  </p>
                </div>
                <div className="plan-features">
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Multi-user Access with Role-Based Permissions
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Approval Workflows for sales & purchases
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Real-Time Collaboration
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">Team-Level AI Insights</span>
                  </div>
                </div>
                <div className="plan-cta">
                  <button
                    className="plan-btn"
                    onClick={() => (window.location.href = "/pricing#team")}
                  >
                    See More...
                  </button>
                </div>
              </div>
              <div className="pricing-card-glass"></div>
            </div>
          </div>

          <div
            className="col-lg-3 col-md-6"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="pricing-card plan-orange">
              <div className="pricing-card-content">
                <div className="pricing-card-header">
                  <h3 className="plan-name">Enterprise</h3>
                  <div className="price-display">
                    <span className="price-text">Custom</span>
                    <span> Pricing</span>
                  </div>
                  <p className="plan-description">
                    Tailored for large businesses with advanced needs
                  </p>
                </div>
                <div className="plan-features">
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      All Advanced Financial Reports
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      Full AI module with predictive insights
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      API access & integrations
                    </span>
                  </div>
                  <div className="plan-feature">
                    <FontAwesomeIcon icon={faCheck} className="check-icon" />
                    <span className="feature-name">
                      24/7 priority enterprise support
                    </span>
                  </div>
                </div>
                <div className="plan-cta">
                  <button
                    className="plan-btn"
                    onClick={() =>
                      (window.location.href = "/pricing#enterprise")
                    }
                  >
                    See More...
                  </button>
                </div>
              </div>
              <div className="pricing-card-glass"></div>
            </div>
          </div>
        </div>
        <div className="pricing-comparison">
          <p>
            All plans include: <span>Core accounting features</span> •{" "}
            <span>Cloud access</span> • <span>Regular updates</span> •{" "}
            <span>Data security</span>
          </p>
        </div>
      </div>

      <style jsx>{`
        .pricing-section {
          padding: 80px 0;
          background-color: ${darkMode ? "#1e1e1e" : "#fff"};
          position: relative;
          overflow: hidden;
        }

        .pricing-section::before,
        .pricing-section::after {
          content: "";
          position: absolute;
          width: 300px;
          height: 300px;
          background: radial-gradient(
            circle,
            rgba(0, 211, 137, 0.05) 0%,
            rgba(0, 211, 137, 0) 70%
          );
          border-radius: 50%;
          z-index: 0;
        }

        .pricing-section::before {
          top: -100px;
          right: -100px;
        }

        .pricing-section::after {
          bottom: -150px;
          left: -150px;
          background: radial-gradient(
            circle,
            rgba(13, 153, 255, 0.05) 0%,
            rgba(13, 153, 255, 0) 70%
          );
        }

        .pricing-title {
          font-size: 36px;
          font-weight: 800;
          color: ${darkMode ? "#f5f5f5" : "#333"};
          margin-bottom: 15px;
          position: relative;
          display: inline-block;
        }

        .pricing-title::after {
          content: "";
          position: absolute;
          height: 4px;
          width: 60px;
          background: linear-gradient(90deg, #00d389, #0d99ff);
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 2px;
        }

        .pricing-subtitle {
          color: ${darkMode ? "#aaa" : "#666"};
          font-size: 16px;
          max-width: 600px;
          margin: 25px auto 40px;
          line-height: 1.6;
        }

        .pricing-cards {
          perspective: 1000px;
        }

        .pricing-card {
          position: relative;
          height: 100%;
          min-height: 520px;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          background-color: ${darkMode ? "#2d2d2d" : "white"};
          transform-style: preserve-3d;
          border: 1px solid ${darkMode ? "#444" : "rgba(240, 240, 240, 1)"};
          backdrop-filter: blur(10px);
        }

        .pricing-tag {
          position: absolute;
          top: 20px;
          right: -34px;
          background: linear-gradient(90deg, #00d389, #00bd7a);
          color: white;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          padding: 6px 40px;
          transform: rotate(45deg);
          box-shadow: 0 2px 10px rgba(0, 211, 137, 0.3);
          z-index: 10;
        }

        .pricing-save-tag {
          position: absolute;
          top: 15px;
          left: 15px;
          background: linear-gradient(90deg, #00d389, #00bd7a);
          color: white;
          font-size: 12px;
          font-weight: 700;
          border-radius: 20px;
          padding: 5px 12px;
          box-shadow: 0 2px 10px rgba(0, 211, 137, 0.3);
          z-index: 10;
        }

        .pricing-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
        }

        .pricing-card-content {
          position: relative;
          z-index: 2;
          height: 100%;
          padding: 30px 20px;
          display: flex;
          flex-direction: column;
          text-align: center;
        }

        .pricing-card-header {
          margin-bottom: 20px;
        }

        .plan-name {
          font-size: 24px;
          font-weight: 700;
          color: #00d389;
          margin-bottom: 10px;
        }

        .price-display {
          margin: 15px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #00d389;
        }

        .price-currency {
          font-size: 18px;
          font-weight: 700;
          position: relative;
          top: -5px;
          margin-right: 2px;
          color: #00d389;
        }

        .price-text {
          font-size: 32px;
          font-weight: 800;
          line-height: 1;
          color: #00d389;
        }

        .plan-description {
          font-size: 14px;
          color: ${darkMode ? "#aaa" : "#666"};
          margin-bottom: 20px;
          line-height: 1.5;
        }

        .plan-features {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 20px;
        }

        .plan-feature {
          display: flex;
          align-items: flex-start;
          padding: 0 10px;
          transition: all 0.3s ease;
          text-align: left;
        }

        .check-icon {
          margin-right: 10px;
          font-size: 14px;
          color: #00d389;
          margin-top: 3px;
        }

        .feature-name {
          font-size: 14px;
          color: ${darkMode ? "#ddd" : "#555"};
          text-align: left;
          line-height: 1.4;
        }

        .plan-cta {
          margin-top: auto;
          padding: 0 10px;
        }

        .plan-btn {
          background: linear-gradient(90deg, #00d389, #00bd7a);
          color: white;
          border: none;
          border-radius: 50px;
          padding: 12px 20px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          box-shadow: 0 4px 15px rgba(0, 211, 137, 0.3);
        }

        .plan-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 211, 137, 0.4);
          background: linear-gradient(90deg, #00c37d, #00aa6e);
        }

        .plan-blue .plan-name,
        .plan-blue .price-currency,
        .plan-blue .price-text,
        .plan-blue .check-icon {
          color: #00d389;
        }

        .plan-purple .plan-name,
        .plan-purple .price-currency,
        .plan-purple .price-text,
        .plan-purple .check-icon {
          color: #00d389;
        }

        .plan-orange .plan-name,
        .plan-orange .check-icon,
        .plan-orange .price-currency,
        .plan-orange .price-text {
          color: #00d389;
        }

        .plan-blue .plan-btn {
          background: linear-gradient(90deg, #00d389, #00bd7a);
          box-shadow: 0 4px 15px rgba(0, 211, 137, 0.3);
        }

        .plan-purple .plan-btn {
          background: linear-gradient(90deg, #00d389, #00bd7a);
          box-shadow: 0 4px 15px rgba(0, 211, 137, 0.3);
        }

        .plan-orange .plan-btn {
          background: linear-gradient(90deg, #00d389, #00bd7a);
          box-shadow: 0 4px 15px rgba(0, 211, 137, 0.3);
        }

        .pricing-comparison {
          text-align: center;
          margin-top: 30px;
          padding: 15px;
          background: ${darkMode
            ? "rgba(45, 45, 45, 0.7)"
            : "rgba(255, 255, 255, 0.7)"};
          border-radius: 10px;
          border: 1px solid ${darkMode ? "#444" : "rgba(240, 240, 240, 1)"};
          font-size: 14px;
          color: ${darkMode ? "#aaa" : "#666"};
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          backdrop-filter: blur(10px);
        }

        .pricing-comparison span {
          color: ${darkMode ? "#f5f5f5" : "#333"};
          font-weight: 600;
          margin: 0 3px;
        }

        @media (max-width: 992px) {
          .pricing-section {
            padding: 60px 0;
          }

          .pricing-title {
            font-size: 32px;
          }

          .pricing-card {
            min-height: 480px;
          }
        }

        @media (max-width: 768px) {
          .pricing-title {
            font-size: 28px;
          }

          .pricing-subtitle {
            font-size: 15px;
            margin-bottom: 30px;
          }

          .pricing-card {
            min-height: 450px;
          }

          .pricing-comparison {
            font-size: 13px;
            padding: 12px;
          }
        }

        @media (max-width: 576px) {
          .pricing-title {
            font-size: 24px;
          }

          .pricing-subtitle {
            font-size: 14px;
          }

          .pricing-card {
            min-height: 420px;
          }

          .plan-name {
            font-size: 22px;
          }

          .price-text {
            font-size: 28px;
          }

          .plan-btn {
            padding: 10px 16px;
            font-size: 13px;
          }
        }
      `}</style>
    </section>
  );
};

export default Pricing;
